import { render, staticRenderFns } from "./customer_follow_tpl.vue?vue&type=template&id=1f5574b1&scoped=true&"
import script from "./customer_follow_tpl.vue?vue&type=script&lang=js&"
export * from "./customer_follow_tpl.vue?vue&type=script&lang=js&"
import style0 from "./customer_follow_tpl.vue?vue&type=style&index=0&id=1f5574b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5574b1",
  null
  
)

export default component.exports